/**
 * Product FAQ Section
 * Handles tab navigation
 */

class ProductFAQ {
  constructor(section) {
    this.section = section;
    this.tabs = this.section.querySelectorAll('.product-faq__tab');
    this.panels = this.section.querySelectorAll('.product-faq__panel');

    this.init();
  }

  init() {
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(e) {
    const clickedTab = e.currentTarget;
    const targetId = clickedTab.getAttribute('data-tab-target');

    // Remove active class from all tabs
    this.tabs.forEach((tab) => {
      tab.classList.remove('product-faq__tab--active');
    });

    // Add active class to clicked tab
    clickedTab.classList.add('product-faq__tab--active');

    // Hide all panels
    this.panels.forEach((panel) => {
      panel.classList.remove('product-faq__panel--active');
    });

    // Show target panel
    const targetPanel = this.section.querySelector(`#${targetId}`);
    if (targetPanel) {
      targetPanel.classList.add('product-faq__panel--active');
    }
  }
}

// Initialize all FAQ sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-section-type="product-faq"]');
  faqSections.forEach((section) => {
    new ProductFAQ(section);
  });
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="product-faq"]');
    if (section) {
      new ProductFAQ(section);
    }
  });
}
